/* eslint-disable */
const CRM = {
  CRM_CONTACT_MEDIA_LIST: 'crm/contact/media/list',
  CRM_CONTACT_CATEGORY_LIST: 'crm/contact/category/list',
  CRM_CONTACT_SUBJECT_LIST: 'crm/contact/subject/list',
  CRM_CONTACT_DEFINITION_LIST: 'crm/contact/definition/list',
  CRM_CONTACT_STATUS_LIST: 'crm/contact/status/list',
  CRM_CONTACT_PRIORIRT_LIST: 'crm/contact/priority/list',
  CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO: 'crm/contact/search/by/customer/info',
  CRM_CONTACT_SEARCH_BY_CUSTOMER_INVOICE: 'crm/contact/search/by/customer/invoice',
  CRM_CONTACT_MASTER_DETAIL_ADD: 'crm/contact/master/detail/add',
  CRM_CONTACT_MASTER_LIST: 'crm/contact/master/list',
  CRM_CONTACT_DETAIL_LIST: 'crm/contact/detail/list',
  CRM_CONTACT_INVOICE_ITEMS_LIST: 'crm/contact/invoice/items/list',
  CRM_CONTACT_MEDIA_REPORT: 'crm/contact/media/report',
  CRM_CONTACT_MEDIA_ADD: 'crm/contact/media/add',
  CRM_CONTACT_MEDIA_REMOVE: 'crm/contact/media/remove',
  CRM_CONTACT_MEDIA_UPDATE: 'crm/contact/media/update',
  CRM_CONTACT_CATEGORY_REPORT: 'crm/contact/category/report',
  CRM_CONTACT_CATEGORY_ADD: 'crm/contact/category/add',
  CRM_CONTACT_CATEGORY_REMOVE: 'crm/contact/category/remove',
  CRM_CONTACT_CATEGORY_UPDATE: 'crm/contact/category/update',
  CRM_CONTACT_SUBJECT_REPORT: 'crm/contact/subject/report',
  CRM_CONTACT_SUBJECT_ADD: 'crm/contact/subject/add',
  CRM_CONTACT_SUBJECT_REMOVE: 'crm/contact/subject/remove',
  CRM_CONTACT_SUBJECT_UPDATE: 'crm/contact/subject/update',
  CRM_CONTACT_DEFINITION_REPORT: 'crm/contact/definition/report',
  CRM_CONTACT_DEFINITION_REMOVE: 'crm/contact/definition/remove',
  CRM_CONTACT_DEFINITION_UPDATE: 'crm/contact/definition/update',
  CRM_CONTACT_DEFINITION_ADD: 'crm/contact/definition/add',
  CRM_CONTACT_PRIORITY_REPORT: 'crm/contact/priority/report',
  CRM_CONTACT_PRIORITY_REMOVE: 'crm/contact/priority/remove',
  CRM_CONTACT_PRIORITY_UPDATE: 'crm/contact/priority/update',
  CRM_CONTACT_PRIORITY_ADD: 'crm/contact/priority/add',
  CRM_CONTACT_STATUS_REPORT: 'crm/contact/status/report',
  CRM_CONTACT_STATUS_REMOVE: 'crm/contact/status/remove',
  CRM_CONTACT_STATUS_UPDATE: 'crm/contact/status/update',
  CRM_CONTACT_STATUS_ADD: 'crm/contact/status/add',
  CRM_CONTACT_MASTER_DETAIL_UPDATE: 'crm/contact/master/detail/update',
  CRM_CONTACT_SMS_SEND_CUSTOMER: 'crm/contact/sms/send/customer',
  CRM_CONTACT_SMS_SEND_RECIPIENT: 'crm/contact/sms/send/recipient',
  CRM_CONTACT_SMS_SEND_GENERAL: 'crm/contact/sms/send/general',
  CRM_PUBLIC_REPORT_RETAIL_CUSTOMER_CLUB_MASTER: 'report/retail/customer/club/master'
}
export default CRM
